var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229.428,
    height: 43.392,
    viewBox: "0 0 229.428 43.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 229.428,
    height: 43.392,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M100.2,0V29.349L124.459,0Z",
    transform: "translate(-75.261)",
    fill: "#f9a928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M89.423,85.772h24.259V56.423Z",
    transform: "translate(-67.166 -42.38)",
    fill: "#f72f2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M19.84,103.685a9.982,9.982,0,0,1-9.92,10.043,10.043,10.043,0,0,1,0-20.085,9.982,9.982,0,0,1,9.92,10.043",
    transform: "translate(0 -70.335)",
    fill: "#ff5b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M19.84,10.043A9.982,9.982,0,0,1,9.92,20.085,9.982,9.982,0,0,1,0,10.043,9.982,9.982,0,0,1,9.92,0a9.982,9.982,0,0,1,9.92,10.043",
    fill: "#008cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M242.545,25.149c0,4.541-3.109,7.036-8.345,7.036H222.663V7.067h10.759c5.236,0,8.386,2.332,8.386,6.832a5.44,5.44,0,0,1-3.355,5.318,6.136,6.136,0,0,1,4.091,5.932m-9.859-8.141c1.923,0,2.945-.736,2.945-2.291s-1.023-2.25-2.945-2.25h-3.764v4.541Zm-3.764,9.777h4.418c1.841,0,2.864-.982,2.864-2.414,0-1.514-1.023-2.455-2.864-2.455h-4.418Z",
    transform: "translate(-167.243 -5.308)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M319.76,38.883a5.539,5.539,0,0,0-2.659-.573c-1.759,0-2.945.777-3.273,2.086V51.2H307.4V32.788h6.423v1.636A5.023,5.023,0,0,1,318,32.379a4.009,4.009,0,0,1,1.759.327Z",
    transform: "translate(-230.893 -24.32)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M371.052,51.073v-.941a7.266,7.266,0,0,1-4.418,1.268c-3.641,0-6.709-2.045-6.709-5.932,0-3.559,3.068-5.85,7.077-5.85a8.275,8.275,0,0,1,4.05,1.022V39.455a2.316,2.316,0,0,0-4.418-.859H360.58c.532-3.559,3.682-6.382,8.427-6.382,5.236,0,8.223,2.782,8.223,7.568V51.073Zm0-6.218a3.041,3.041,0,0,0-2.7-1.268c-1.268,0-2.536.532-2.536,1.759,0,1.268,1.268,1.8,2.536,1.8a3.115,3.115,0,0,0,2.7-1.227Z",
    transform: "translate(-270.341 -24.196)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M438.039,32.788h6.423v1.6a6.675,6.675,0,0,1,4.95-2c4.091,0,6.5,2.659,6.5,6.75V51.2h-6.382V40.683a2.314,2.314,0,0,0-2.413-2.618,2.637,2.637,0,0,0-2.659,2V51.2h-6.423Z",
    transform: "translate(-329.012 -24.32)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M537.086,0V26.878h-6.423V25.405a6.4,6.4,0,0,1-4.541,1.882c-5.318,0-8.223-4.3-8.223-9.613s2.9-9.614,8.223-9.614a6.4,6.4,0,0,1,4.541,1.882V0m0,15.218a3.207,3.207,0,0,0-2.823-1.718c-2.209,0-3.518,1.8-3.518,4.173s1.309,4.132,3.518,4.132a3.086,3.086,0,0,0,2.823-1.718Z",
    transform: "translate(-388.996 -0.001)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M608.25,45.511a2.25,2.25,0,0,0,2.332,1.6c1.064,0,1.882-.409,1.882-1.268,0-.7-.532-.941-1.432-1.145l-3.6-.736c-3.068-.655-5.073-2.128-5.073-5.36,0-3.927,3.518-6.218,7.854-6.218,5.032,0,7.773,2.331,8.346,5.972h-5.932c-.2-.777-.778-1.473-2.25-1.473-.941,0-1.718.409-1.718,1.227,0,.573.409.859,1.268,1.023l3.641.859c3.355.777,5.154,2.537,5.154,5.523,0,3.928-3.559,6.1-8.059,6.1-4.7,0-8.1-2.128-8.673-6.1Z",
    transform: "translate(-452.157 -24.321)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M683.676,57.7h-6.423V32.789h6.423v1.473a6.4,6.4,0,0,1,4.541-1.882c5.318,0,8.223,4.336,8.223,9.613,0,5.237-2.9,9.613-8.223,9.613a6.4,6.4,0,0,1-4.541-1.882Zm0-13.3a3.131,3.131,0,0,0,2.823,1.718c2.209,0,3.518-1.759,3.518-4.132s-1.309-4.173-3.518-4.173a3.159,3.159,0,0,0-2.823,1.718Z",
    transform: "translate(-508.687 -24.321)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M762.9,6.913a3.461,3.461,0,1,1,3.641-3.436A3.453,3.453,0,0,1,762.9,6.913",
    transform: "translate(-570.279)",
    fill: "#f9a928"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 6.423,
    height: 18.409,
    transform: "translate(189.386 8.468)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M807.1,38.883a5.539,5.539,0,0,0-2.659-.573c-1.759,0-2.945.777-3.273,2.086V51.2h-6.423V32.788h6.423v1.636a5.023,5.023,0,0,1,4.173-2.045,4.009,4.009,0,0,1,1.759.327Z",
    transform: "translate(-596.933 -24.32)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M867.13,44.774c-.655,4.255-3.846,6.832-8.632,6.832-5.645,0-9.368-3.886-9.368-9.613,0-5.686,3.927-9.614,9.245-9.614,5.646,0,8.836,3.764,8.836,9.246v1.6h-11.9c.2,2.209,1.35,3.4,3.191,3.4a2.551,2.551,0,0,0,2.7-1.841Zm-11.7-4.745h5.564a2.57,2.57,0,0,0-2.618-2.659c-1.514,0-2.536.941-2.945,2.659",
    transform: "translate(-637.784 -24.32)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M226.36,126.919a3.651,3.651,0,0,1,3.8,3h-1.239a2.551,2.551,0,0,0-2.558-1.875c-1.859,0-3.114,1.573-3.114,3.893,0,2.3,1.239,3.893,3.114,3.893a2.546,2.546,0,0,0,2.558-1.891h1.239a3.661,3.661,0,0,1-3.8,3.019c-2.463,0-4.369-1.986-4.369-5.021s1.907-5.02,4.369-5.02",
    transform: "translate(-166.738 -95.329)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M264.936,139.1a1.509,1.509,0,0,0-.794-.19,1.708,1.708,0,0,0-1.637,1.318v4.735h-1.191v-7.054h1.191v.921a1.969,1.969,0,0,1,1.748-1.065,1.724,1.724,0,0,1,.683.111Z",
    transform: "translate(-196.274 -103.479)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M285.018,142.855a2.691,2.691,0,0,1-2.844,2.256c-1.922,0-3.241-1.477-3.241-3.654,0-2.113,1.287-3.686,3.209-3.686,1.938,0,2.971,1.413,2.971,3.463v.429h-4.989c.016,1.509.858,2.431,2.049,2.431a1.625,1.625,0,0,0,1.716-1.239Zm-4.861-2.1h3.749a1.772,1.772,0,0,0-1.747-1.97,2.022,2.022,0,0,0-2,1.97",
    transform: "translate(-209.507 -103.48)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M312.585,144.967v-.524a2.826,2.826,0,0,1-1.859.652,2.373,2.373,0,0,1-2.621-2.256c0-1.319,1.191-2.208,2.7-2.208a3.022,3.022,0,0,1,1.779.572v-.89a1.423,1.423,0,0,0-1.557-1.509,1.368,1.368,0,0,0-1.446.969h-1.176a2.556,2.556,0,0,1,2.638-2,2.392,2.392,0,0,1,2.685,2.494v4.7Zm0-2.479a1.766,1.766,0,0,0-1.652-.874c-.858,0-1.684.382-1.684,1.224,0,.858.826,1.255,1.684,1.255a1.765,1.765,0,0,0,1.652-.874Z",
    transform: "translate(-231.419 -103.479)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M336.572,133.752h-1.144v-1.017h1.144v-1.859h1.191v1.859h1.7v1.017h-1.7v4.131c0,.683.334.985.937.985a1.757,1.757,0,0,0,.922-.286v1.112a2.507,2.507,0,0,1-1.112.238,1.759,1.759,0,0,1-1.938-1.922Z",
    transform: "translate(-251.941 -98.301)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M358.978,128.252a.773.773,0,0,1-.762-.763.771.771,0,0,1,1.541,0,.777.777,0,0,1-.779.763m.6,8.42h-1.191v-7.054h1.191Z",
    transform: "translate(-269.057 -95.185)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M371.865,145.4l-2.733-7.054h1.287l2.065,5.545,2.049-5.545h1.255L373.04,145.4Z",
    transform: "translate(-277.256 -103.911)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M404.836,142.855a2.691,2.691,0,0,1-2.844,2.256c-1.922,0-3.241-1.477-3.241-3.654,0-2.113,1.287-3.686,3.209-3.686,1.938,0,2.971,1.413,2.971,3.463v.429h-4.989c.016,1.509.858,2.431,2.049,2.431a1.625,1.625,0,0,0,1.716-1.239Zm-4.861-2.1h3.749a1.772,1.772,0,0,0-1.747-1.97,2.022,2.022,0,0,0-2,1.97",
    transform: "translate(-299.503 -103.48)",
    fill: "#0d0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M428.97,143.029a1.573,1.573,0,0,0,1.668,1.08c.842,0,1.446-.334,1.446-1.049,0-.493-.318-.794-1.049-.985l-1.4-.365c-1-.254-1.7-.763-1.7-1.859a2.247,2.247,0,0,1,2.526-2.081,2.485,2.485,0,0,1,2.733,2H432a1.447,1.447,0,0,0-1.557-1c-.7,0-1.351.334-1.351,1.017,0,.476.318.7.985.89l1.366.334c1.207.318,1.8.985,1.8,1.97,0,1.335-1.112,2.129-2.621,2.129a2.65,2.65,0,0,1-2.891-2.081Z",
    transform: "translate(-321.27 -103.479)",
    fill: "#0d0e0e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.98d5882416381c5695e4250915c08cc4.svg";
export { ForwardRef as ReactComponent };